import { __awaiter } from "tslib";
/* Copyright 2021, Milkdown by Mirone. */
import re from 'remark';
import { createSlice } from '../context';
import { createTimer } from '../timing';
import { ConfigReady } from './config';
import { prosePluginsCtx } from './prose-plugin-factory';
import { remarkPluginsCtx } from './remark-plugin-factory';
export const InitReady = createTimer('InitReady');
export const initTimerCtx = createSlice([], 'initTimer');
export const editorCtx = createSlice({}, 'editor');
export const remarkCtx = createSlice(re(), 'remark');
export const init = (editor) => (pre) => {
    pre.inject(editorCtx, editor)
        .inject(prosePluginsCtx)
        .inject(remarkPluginsCtx)
        .inject(remarkCtx, re())
        .inject(initTimerCtx, [ConfigReady])
        .record(InitReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(initTimerCtx);
        const remark = ctx.get(remarkCtx);
        const remarkPlugins = ctx.get(remarkPluginsCtx);
        const processor = remarkPlugins.reduce((acc, plug) => acc.use(plug), remark);
        ctx.set(remarkCtx, processor);
        ctx.done(InitReady);
    });
};
//# sourceMappingURL=init.js.map